var map = {
	"./bowls-and-cups.svg": 876,
	"./collars.svg": 121,
	"./medicines.svg": 101,
	"./pet-food.svg": 238,
	"./shampoos.svg": 165,
	"./sleeping-area.svg": 454,
	"./toys.svg": 6,
	"./transportation.svg": 691,
	"./vitamins.svg": 237
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 455;